//******************************//
var environment_array = {
  'debug': 1,
  'breakpoint': 1023,
  'sliders': {
    'timer': null
  },
  'map': {
    'class': "map",
    'latitude': 0,
    'longitude': 0,
    'zoom': 15,
    'icon': ""
  }
};
//******************************//

//******************************//
function customHashTag(object){

  var hash = (window.location.hash != "" ? window.location.hash.split("#")[1] : "");

  if(object.action == "setup"){

    /* -- Newsletter Signup -- */
    if(hash == "signup"){
      setTimeout(function() {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'YypsEj']);
      }, 1000);
    }
  }
  
}
//******************************//

//******************************//
function customCalculateAspectRatioFit(object){
  var ratio = [object.max_w / object.original_w, object.max_h / object.original_h ];
  object.ratio = Math.min(ratio[0], ratio[1]);
  object.ratio = (object.ratio * 100) / 100;
  if(object.required == "width"){
    return Math.round(object.original_w*object.ratio);
  }
  if(object.required == "height"){
    return Math.round(object.original_h*object.ratio);
  }
}
//******************************//

//******************************//
function customJsTriggers(object){

  storage = {
    'html': ""
  };

  if(object.action == "setup"){
    $("[data-trigger='js']").unbind().click(function(event){

      /* -- Modal Window Trigger -- */
      if($(this).attr("data-trigger-id") == "modal"){
        customModalWindow({'action': "trigger", 'content': $(this).find(".profile").html() });
        customResponsiveResizeScroll({'action': "resize"});
      }

      /* -- Newsletter -- */
      if($(this).attr("data-trigger-id") == "newsletter"){
        $(".modal-window>.inner>.newsletter").addClass("active");
        customModalWindow({'action': "trigger", 'content': "" });
      }

      /* -- Klaviyo -- */
      if($(this).attr("data-trigger-id") == "klaviyo"){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'YypsEj']);
      }

      /* -- Menu -- */
      if($(this).attr("data-trigger-id") == "menu"){
        if($("header").hasClass("open")){
          $("header").removeClass("open");
        }else{
          $("header").addClass("open");
        }
        event.preventDefault();
      }

      /* -- Search -- */
      if(
        $(this).attr("data-trigger-id") == "search" /* &&
        $(this).parent().find("#search").val() != "" */
      ){
        customSearchPage({'input': $(this).parent().find("#search") });
      }
    });
  }
  
}
//******************************//

//******************************//
function customNewsletterTrigger(object){
  if(object.type == "open"){
    /*-- Check for cookie --*/
    if(cookieControl({'type': "get", 'cookie': object.cookie}) == null){
      setTimeout(function() {
        cookieControl({'type': "set", 'cookie': object.cookie, 'value': object.value, 'expiry': (48 * 3600 * 1000) });
        $(".modal-window>.inner>.newsletter").addClass("active");
        customModalWindow({'action': "trigger", 'content': "" });
      }, object.timer*1000);
    }
    
  }
}
//******************************//

//******************************//
function customModalTrigger(object){
  if(object.type == "open"){
    /*-- Check for cookie --*/
    if(cookieControl({'type': "get", 'cookie': object.cookie}) == null){
      setTimeout(function() {
        cookieControl({'type': "set", 'cookie': object.cookie, 'value': object.value, 'expiry': (1 * 3600 * 1000) });
        $(".modal-window").addClass("prompt")
        customModalWindow({'action': "trigger", 'content': "<video autoplay='' muted='' loop='' playsinline=''><source src='https://cdn.shopify.com/videos/c/o/v/71ef08f17dba4c51aef8e049de892e8f.mp4' type='video/mp4'>Your browser does not support the video tag.</video>" });
      }, object.timer*1000);
    } 
  }
}
//******************************//

//******************************//
function customSearchPage(object){
  window.location.href = "/search?q="+object.input.val();
}
//******************************//

//******************************//
function customModalWindow(object){
  if(object.action == "trigger"){
     if($(".modal-window").hasClass("active")){
       $(".modal-window>.inner>.newsletter").removeClass("active");
       $(".modal-window").removeClass("active").find(".inner>.content").html("");
     }else{
       $(".modal-window").addClass("active").find(".inner>.content").html(object.content);
     }
  }
}
//******************************//

//******************************//
function customMapControl(object){
  
  if(object.action == "setup"){
    if($("."+environment_array.map.class)[0]){
      google.maps.event.addDomListener(window, 'load', customMapControl({'action': 'build'}) );
      google.maps.event.addDomListener(window, "resize", function() {
        environment_array.map.center = environment_array.map.google.getCenter();
        google.maps.event.trigger(environment_array.map.google, "resize");
        environment_array.map.google.setCenter(environment_array.map.center);
      });
    }
  }
  
  if(object.action == "build"){
    environment_array.map.object = $("."+environment_array.map.class)[0];
    environment_array.map.options = {
      center: {lat: environment_array.map.latitude, lng: environment_array.map.longitude},
      zoom: environment_array.map.zoom,
      scrollwheel: false,
      zoomControl: false,
      disableDefaultUI: true,
      styles: [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d6a444"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}]
    };
    environment_array.map.latlng = new google.maps.LatLng(environment_array.map.latitude, environment_array.map.longitude);
    environment_array.map.google = new google.maps.Map(environment_array.map.object, environment_array.map.options);
    environment_array.map.icon = $(".map").attr("data-map-icon");
    environment_array.map.icon = new google.maps.MarkerImage(environment_array.map.icon, null, null, null, new google.maps.Size(40,40));
    environment_array.map.marker = new google.maps.Marker({
      position: environment_array.map.latlng,
      map: environment_array.map.google,
      title: "",
      icon: environment_array.map.icon
    });
  }
}
//******************************//

//******************************//
function customSliderSetup(object){

  if(object.action == "setup"){
    environment_array.sliders.timer = setTimeout(function(){
      customSliderSetup({'action': "animate" });
    }, 1000);
    if(environment_array.debug){
      /* console.log("Time Setup!"); */
    }
  }

  if(object.action == "destroy"){
    clearTimeout(environment_array.sliders.timer);
    if(environment_array.debug){
      /* console.log("Time Destroyed!"); */
    }
  }

  if(object.action == "animate"){
    customSliderSetup({'action': "destroy" });

    $("[data-sliders]").each(function(){
      
      /* -- Add Extra Item (loop) -- */
      if(
        parseInt($(this).attr("data-sliders")) == 0 &&
        $(this).attr("data-sliders-total") != undefined &&
        parseInt($(this).attr("data-sliders-total")) > 1
      ){
        $(this).attr({'data-sliders': 1 });
        $(this).find('ul>li:first').clone(true).appendTo($(this).find("ul"));
      }

      /* -- Control Slider(s) -- */
      if(
        $(this).find("ul>li").length > 1 &&
        customInView({'div': $(this) })
      ){
        $(this).attr({"data-sliders-counter": (parseInt($(this).attr("data-sliders-counter"))+1) });
        console.log((parseInt($(this).attr("data-sliders-counter"))+1));
        if(
          parseInt($(this).attr("data-sliders-timer")) == parseInt($(this).attr("data-sliders-counter")) &&
          $(this).attr("data-sliders-id") != undefined &&
          $(this).attr("data-sliders-total") != undefined &&
          parseInt($(this).attr("data-sliders-total")) > 1 &&
          $(this).attr("data-sliders-selected") != undefined
        ){
          if(parseInt($(this).attr("data-sliders-selected")) < (parseInt($(this).attr("data-sliders-total")-1))){
            $(this).attr({'data-sliders-selected': (parseInt($(this).attr("data-sliders-selected"))+1), 'data-sliders-counter': 0 });
          }else{
            $(this).attr({'data-sliders-selected': (parseInt($(this).attr("data-sliders-selected"))+1), 'data-sliders-counter': 0 });
            var div = $(this);
            setTimeout(function(){
              div.find("ul").addClass("reset").css({'margin-left': 0 });
              div.attr({'data-sliders-selected': 0 });
            }, 375);
            setTimeout(function(){
              div.find("ul").removeClass("reset");
            }, 800);
          } 
        }
      }
    });

    /* -- Update View -- */
    customResponsiveResizeScroll({'action': "resize"});

    /* -- Trigger Timer Again -- */
    customSliderSetup({'action': "setup"})
  }
  
}
//******************************//

//******************************//
function customResponsiveNavigation(object){

  var storage = {
    'header': {
      'h1': 0,
      'h2': 0
    }
  };

  if(object.action == "setup"){

    $(".nav-toggle").unbind().click(function(){
      if($(".nav-toggle").hasClass("open")){
        customResponsiveNavigation({'action': 'close'});
      }else{
        customResponsiveNavigation({'action': 'open'});
      }
    });
    
    $("header").mouseleave(function(event){
      if($(this).hasClass("open")){
        $(this).removeClass("open");
      }
    });
  }

  if(object.action == "open"){
    $(".nav-toggle, #MainContent, #shopify-section-footer-custom, #shopify-section-header-custom, #shopify-section-announcement-bar-custom").removeClass("closed").addClass("open");
    customResponsiveResizeScroll({'action': "resize"});
  }

  if(object.action == "close"){
    $(".nav-toggle, #MainContent, #shopify-section-footer-custom, #shopify-section-header-custom, #shopify-section-announcement-bar-custom").removeClass("open").addClass("closed");
    customResponsiveResizeScroll({'action': "resize"});
  }

  if(object.action == "display"){
    
    if(object.type == "resize"){
      storage.header.h1 = $(".announcement-bar.custom").outerHeight();
      if(storage.header.h1 == undefined){
        storage.header.h1 = 0;
      }
      if(
        $(".custom-banner").attr("data-header") != undefined &&
        $(".custom-banner").attr("data-header") == "transparent"
      ){
        storage.header.h2 = 0;
      }else{
        if($(window).width() <= environment_array.breakpoint){
          storage.header.h2 = 60;
        }else{
          storage.header.h2 = 70;
        }
      }
      
      $("header").css({'margin-top': (storage.header.h1) });
      //$("#MainContent").css({'margin-top': (storage.header.h1+storage.header.h2), 'min-height': $(window).height()-($("footer").height()) });

      if($(window).width() <= environment_array.breakpoint){
        $("header>.outer>.inner>.nav").css({'height': $(window).height()+100, 'margin-left': 0 });
      }else{
        $("header>.outer>.inner>.nav").css({'height': "auto", 'margin-left': ($("header>.outer>.inner").width()/2)-($("[data-trigger-id='menu']").width()/2) });
      }
    }
    
    if(object.type == "scroll"){
      if($(window).scrollTop() > 20){
        $("header").addClass("solid");
      }else{
        $("header").removeClass("solid");
      }
    }
    
  }
  
}
//******************************//

//******************************//
function customInView(object){
  var win = $(window);
  if(object.direct){
    obj = object.div;
  }else{
    obj = $(object.div);
  }
  var scrollPosition = win.scrollTop();
  var visibleArea = win.scrollTop() + win.height();
  var objEndPos = (obj.offset().top + obj.outerHeight());
  return(visibleArea >= (objEndPos-obj.height()) && scrollPosition <= (objEndPos-obj.height()) ? true : false);
}
//******************************//

//******************************//
function customResponsiveResizeScroll(object){

  var storage = {
    'homepage': {
      'video': {
        'w': 0,
        'h': 0
      }
    }
  };

  /* -- Navigation (Control) -- */
  customResponsiveNavigation({'action': "display", 'type': object.action});

  /* -- Resize -- */
  if(object.action == "resize"){

    /* -- Activate Header -- */
    $("header, footer").addClass("active");

    /* -- Custom Banner (Video Control) -- */
    if(
      $(".custom-banner").hasClass("_fullbleed") &&
      $(".custom-banner").hasClass("_video") &&
      $(".custom-banner>.asset>video").attr("data-ratio-w") != undefined &&
      $(".custom-banner>.asset>video").attr("data-ratio-h") != undefined
    ){

      if($(window).width() < 1024){
        $(".custom-banner").css({'height': Math.round(($(window).height()/3) * 2.2) });
      }else{
        $(".custom-banner").css({'height': Math.round(($(window).height()/3) * 2.2) });
      }

      storage.homepage.video.w = customCalculateAspectRatioFit({'required': "width", 'original_w': $(".custom-banner>.asset>video").attr("data-ratio-w"), 'original_h': $(".custom-banner>.asset>video").attr("data-ratio-h"), 'max_w': 6000, 'max_h': $(".custom-banner").height() });
      storage.homepage.video.h = customCalculateAspectRatioFit({'required': "height", 'original_w': $(".custom-banner>.asset>video").attr("data-ratio-w"), 'original_h': $(".custom-banner>.asset>video").attr("data-ratio-h"), 'max_w': $(".custom-banner").width(), 'max_h': 6000 });
      
      if(storage.homepage.video.w < $(".custom-banner").width() && storage.homepage.video.h >= $(".custom-banner>.asset").height()){
        $(".custom-banner>.asset").css({'width': $(".custom-banner").width(), 'height': storage.homepage.video.h, 'margin-top': -Math.round((storage.homepage.video.h-$(".custom-banner").height())/2), 'margin-left': 0});
      }else if(storage.homepage.video.h < $(".custom-banner").height() && storage.homepage.video.w > $(".custom-banner").width()){
        $(".custom-banner>.asset").css({'width': storage.homepage.video.w, 'height': $(".custom-banner").height(), 'margin-top': 0, 'margin-left': -Math.round((storage.homepage.video.w-$(".custom-banner").width())/2) });
      }else{
        // Empty
      }
    }

    /* -- Custom  Grid -- */
    $("[data-grid]").each(function(){
      $(this).find("li").css({'height': $(this).find("li").width() });
    });

    /* -- Activate Media Asset -- */
    if(!$("#MainContent").hasClass("active")){
      $("#MainContent").addClass("active");
    }

    /* -- Sliders -- */
    $("[data-sliders]").each(function(){
      $(this).find("ul>li").css({'width': $(this).innerWidth() });
      $(this).find("ul").css({'margin-left': -(parseInt($(this).attr("data-sliders-selected"))*$(this).innerWidth()) });
    });

    /* -- Modal Window -- */
    $(".modal-window").css(
      {
        'width': $(window).width(), 
        'height': $(window).height()
      }
    );
  }
}
//******************************//

//******************************//
function customTheme(object){
  /* -- Setup -- */
  if(object.action == "setup"){
    if(
      typeof theme != 'undefined' &&
      typeof theme.navigation != 'undefined' &&
      typeof theme.bg != 'undefined'
    ){
      /* -- Selected Theme -- */
      $("body, .module._page, .announcement-bar.custom").addClass(theme.bg);
      $("header").addClass(theme.navigation);
    }else{
      /* -- Default Theme -- */
      $("body, .module._page, .announcement-bar.custom").addClass("_white");
      $("header").addClass("_white");
    }
  }
}
//******************************//

//******************************//
/* -- Cookie Policy -- */
function cookieControl(object){

	if(object.type == "set"){
		var expires = new Date();
		expires.setTime(expires.getTime() + object.expiry);
		document.cookie = object.cookie + '=' + object.value + ';secure;expires=' + expires.toUTCString();
	}

	if(object.type == "get"){
		var keyValue = document.cookie.match('(^|;) ?' + object.cookie + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : null;
	}

}
//******************************//

//******************************//
$(window).ready(function(){
  $("header * .nav > ul > li > ul > li._search > input").keypress(function(e){
    if(e.keyCode==13){
      customSearchPage({'input': $(this) });
    }  
  });
});
//******************************//

//******************************//
$(window).scroll((function(event){
  customResponsiveResizeScroll({'action': "scroll"});
}));
//******************************//

//******************************//
$(window).resize((function(event){
  customResponsiveResizeScroll({'action': "resize"});
}));
//******************************//

//******************************//
$(window).bind("load", (function(event){

  /* -- Setup Navigation -- */
  customResponsiveNavigation({'action': "setup"});

  /* -- Setup Theme -- */
  customTheme({'action': "setup"});
  
  /* -- Window Display -- */
  customResponsiveResizeScroll({'action': "resize"});
  customResponsiveResizeScroll({'action': "scroll"});

  /* -- Slider(s) -- */
  customSliderSetup({'action': "setup"});

  /* -- Load Map -- */
  customMapControl({'action': "setup"});

  /* -- Load JS Triggers -- */
  customJsTriggers({'action': "setup"});

  /* -- Modal Newsletter -- */
  /* customNewsletterTrigger({'type': "open", 'cookie': "modal-newsletter", 'value': 1, 'timer': 5 }); */

  /* -- Prompt -- */
  /* customModalTrigger({'type': "open", 'cookie': "modal-prompt", 'value': 1, 'timer': 2 }); */

  /* -- Hash Tag Detection -- */
  customHashTag({'action': "setup"});
  
}));
//******************************//

